import { useState, useEffect } from "react";

const LOGO_B64 = "/logo.png";

const SERVICES = [
  {
    icon: "☉",
    title: "Kundli Analysis",
    titleHi: "कुण्डली विश्लेषण",
    desc: "Comprehensive birth chart reading covering career, relationships, health, and life path with detailed planetary analysis and practical remedies.",
    highlights: ["Career & Finance", "Relationships", "Health", "Dasha Predictions"],
  },
  {
    icon: "☽",
    title: "Numerology",
    titleHi: "अंक ज्योतिष",
    desc: "Decode your life through numbers — name correction, lucky dates, business naming, and personal year forecast for clarity and direction.",
    highlights: ["Name Correction", "Lucky Numbers", "Business Naming", "Annual Forecast"],
  },
  {
    icon: "✦",
    title: "Tarot Reading",
    titleHi: "टैरो रीडिंग",
    desc: "Intuitive card guidance for love, career decisions, or any pressing question. Each session is personal, compassionate, and clarity-driven.",
    highlights: ["Love & Relationships", "Career Choices", "Yes/No Clarity", "Monthly Outlook"],
  },
  {
    icon: "◯",
    title: "Kundli Matching",
    titleHi: "कुण्डली मिलान",
    desc: "Complete Kundli Milan for marriage compatibility — Ashtakoot Gun Milan, Manglik Dosha check, and detailed Dasha alignment for both partners.",
    highlights: ["Gun Milan Score", "Manglik Check", "Dasha Compatibility", "Remedies"],
  },
];

const TESTIMONIALS = [
  {
    text: "She guided me through a difficult time in my life and helped me find my way back to myself",
    name: "Janvi",
    loc: "Gurugram",
  },
  {
    text: "I was stressed about my relationship with my son, her numerology advice helped me to understand him better and improve our relationship",
    name: "Reema",
    loc: "Mandi Dabwali",
  },
  {
    text: "She doesn't just read cards — she listens. The tarot session gave me clarity I hadn't found in months of overthinking.",
    name: "Pooja",
    loc: "Patiala",
  },
  {
    text: "She did Dasha prediction for me and it was very accurate. Her remedies helped me to improve my kid's health and career",
    name: "Renu",
    loc: "Nabha",
  },
];

// --- Floating Mandala SVG ---
function FloatingMandala({ size, top, left, right, opacity, speed, delay }) {
  const petals = 12;
  const r1 = size * 0.38;
  const r2 = size * 0.24;
  const cx = size / 2, cy = size / 2;
  let paths = "";
  for (let i = 0; i < petals; i++) {
    const a = (i * 360) / petals;
    const rad = (a * Math.PI) / 180;
    const x = cx + r1 * Math.cos(rad);
    const y = cy + r1 * Math.sin(rad);
    paths += `<ellipse cx="${x}" cy="${y}" rx="${r2*0.35}" ry="${r2}" transform="rotate(${a} ${x} ${y})" fill="none" stroke="currentColor" stroke-width="0.6" opacity="0.5"/>`;
  }
  for (let i = 0; i < petals * 2; i++) {
    const a = (i * 360) / (petals * 2);
    const rad = (a * Math.PI) / 180;
    const x = cx + r2 * 0.85 * Math.cos(rad);
    const y = cy + r2 * 0.85 * Math.sin(rad);
    paths += `<circle cx="${x}" cy="${y}" r="1.2" fill="currentColor" opacity="0.35"/>`;
  }
  const style = {
    position: "absolute", top, left, right, opacity,
    color: "#6B1D2A",
    "--o": opacity,
    animation: `spin ${speed}s linear infinite, breathe ${speed * 0.15}s ease-in-out infinite`,
    animationDelay: `${delay || 0}s`,
    pointerEvents: "none", zIndex: 0,
  };
  return (
    <div style={style} dangerouslySetInnerHTML={{
      __html: `<svg viewBox="0 0 ${size} ${size}" width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
        <circle cx="${cx}" cy="${cy}" r="${r1}" fill="none" stroke="currentColor" stroke-width="0.5" opacity="0.2"/>
        <circle cx="${cx}" cy="${cy}" r="${r2}" fill="none" stroke="currentColor" stroke-width="0.5" opacity="0.25"/>
        <circle cx="${cx}" cy="${cy}" r="${r1*1.12}" fill="none" stroke="currentColor" stroke-width="0.3" opacity="0.12"/>
        ${paths}
      </svg>`
    }}/>
  );
}

export default function App() {
  const [activeT, setActiveT] = useState(0);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [expandedService, setExpandedService] = useState(null);

  useEffect(() => {
    const t = setInterval(() => setActiveT(i => (i + 1) % TESTIMONIALS.length), 5500);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const scrollTo = id => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  const NAME = "Mrs. Sunita Bansal";
  const WA = "917888417678";
  const EMAIL = "sunitabsl83@gmail.com";
  const YEARS = 10;


  return (
    <div style={{ fontFamily: "var(--sans)", background: "var(--bg)", color: "var(--text)", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Inter:wght@300;400;500;600&family=Tiro+Devanagari+Hindi&display=swap');
        :root {
          --bg: #FBF7F0;
          --bg-warm: #F5EDE0;
          --bg-card: #FFFFFF;
          --saffron: #D4820A;
          --saffron-deep: #B5690A;
          --saffron-light: #F0C668;
          --maroon: #6B1D2A;
          --maroon-light: #8B3040;
          --text: #2C1810;
          --text-secondary: #6B5A4E;
          --text-muted: #9B8E82;
          --border: rgba(180,150,110,0.18);
          --serif: 'Cormorant Garamond', Georgia, serif;
          --sans: 'Inter', system-ui, sans-serif;
          --hindi: 'Tiro Devanagari Hindi', serif;
          --radius: 14px;
        }
        * { margin:0; padding:0; box-sizing:border-box; }
        html { scroll-behavior: smooth; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes float { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-12px); } }
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes breathe { 0%,100% { transform: scale(1); opacity: var(--o); } 50% { transform: scale(1.08); opacity: calc(var(--o) + 0.08); } }
        .nav {
          position:fixed;top:0;left:0;right:0;z-index:100;
          display:flex;align-items:center;justify-content:space-between;
          padding:12px 32px;
          transition: background 0.3s, box-shadow 0.3s;
        }
        .nav.scrolled {
          background:rgba(251,247,240,0.95);
          backdrop-filter:blur(10px);
          box-shadow:0 1px 0 var(--border);
        }
        .nav-brand { display:flex;align-items:center;gap:10px;cursor:pointer; }
        .nav-brand img { height:90px;width:150px;border-radius:50%; }
        .nav-brand-text { font-family:var(--serif);font-size:18px;font-weight:700;color:var(--maroon); }
        .nav-links { display:flex;gap:28px;list-style:none; }
        .nav-links a {
          color:var(--text-secondary);text-decoration:none;font-size:14px;font-weight:500;
          letter-spacing:0.04em;cursor:pointer;transition:color 0.2s;
        }
        .nav-links a:hover { color:var(--saffron-deep); }
        .nav-cta {
          background:var(--saffron);color:#fff;border:none;padding:10px 22px;
          border-radius:100px;font-size:14px;font-weight:600;cursor:pointer;
          font-family:var(--sans);transition:all 0.2s;
        }
        .nav-cta:hover { background:var(--saffron-deep);transform:translateY(-1px); }
        .hamburger { display:none;background:none;border:none;color:var(--maroon);font-size:26px;cursor:pointer;position:relative;z-index:101; }

        .hero {
          min-height:100vh;display:flex;flex-direction:column;align-items:center;
          justify-content:center;text-align:center;padding:100px 24px 40px;
          position:relative;overflow:hidden;
          background: linear-gradient(180deg, var(--bg) 0%, var(--bg-warm) 100%);
        }
        .hero-content { position:relative;z-index:1;max-width:800px;width:100%; }
        .hero-eyebrow {
          font-size:13px;letter-spacing:0.18em;text-transform:uppercase;
          color:var(--saffron-deep);margin-bottom:20px;font-weight:600;
        }
        .hero-name {
          font-family:var(--serif);font-size:clamp(42px,8vw,76px);
          color:var(--maroon);line-height:1.08;margin-bottom:10px;font-weight:700;
        }
        .hero-tagline-hi {
          font-family:var(--hindi);font-size:clamp(18px,3vw,24px);
          color:var(--text-secondary);margin-bottom:6px;
        }
        .hero-tagline {
          font-size:16px;color:var(--text-muted);letter-spacing:0.1em;
          text-transform:uppercase;margin-bottom:32px;
        }
        .hero-intro {
          font-size:18px;line-height:1.8;color:var(--text-secondary);
          max-width:580px;margin:0 auto 40px;font-weight:300;
        }

        .service-pills {
          display:flex;flex-wrap:wrap;gap:10px;justify-content:center;margin-bottom:36px;
        }
        .service-pill {
          background:var(--bg-card);border:1.5px solid var(--border);
          border-radius:100px;padding:10px 20px;font-size:15px;font-weight:500;
          color:var(--text);cursor:pointer;transition:all 0.2s;
          display:flex;align-items:center;gap:8px;
          font-family:var(--sans);
        }
        .service-pill:hover, .service-pill.active {
          border-color:var(--saffron);background:rgba(212,130,10,0.07);color:var(--saffron-deep);
        }
        .service-pill .pill-icon { font-size:18px; }

        .hero-actions { display:flex;gap:14px;justify-content:center;flex-wrap:wrap; }
        .btn-wa {
          background:var(--saffron);color:#fff;border:none;padding:14px 32px;
          border-radius:100px;font-size:16px;font-weight:600;cursor:pointer;
          font-family:var(--sans);text-decoration:none;display:inline-flex;
          align-items:center;gap:8px;transition:all 0.2s;
        }
        .btn-wa:hover { background:var(--saffron-deep);transform:translateY(-1px); }
        .btn-ghost {
          background:transparent;color:var(--maroon);border:1.5px solid var(--maroon);
          padding:14px 32px;border-radius:100px;font-size:16px;font-weight:500;
          cursor:pointer;font-family:var(--sans);text-decoration:none;transition:all 0.2s;
        }
        .btn-ghost:hover { background:var(--maroon);color:#fff; }

        .section { padding:80px 24px;max-width:960px;margin:0 auto; }
        .section-label {
          font-size:12px;letter-spacing:0.2em;text-transform:uppercase;
          color:var(--saffron-deep);margin-bottom:10px;font-weight:600;
        }
        .section-title {
          font-family:var(--serif);font-size:clamp(30px,5vw,44px);
          color:var(--maroon);margin-bottom:14px;line-height:1.15;font-weight:700;
        }
        .section-sub {
          font-size:17px;color:var(--text-secondary);max-width:600px;
          line-height:1.75;font-weight:300;margin-bottom:40px;
        }

        .services-detail { display:flex;flex-direction:column;gap:24px; }
        .svc-card {
          background:var(--bg-card);border:1.5px solid var(--border);
          border-radius:var(--radius);padding:32px;transition:all 0.2s;
          cursor:pointer;
        }
        .svc-card:hover, .svc-card.open { border-color:var(--saffron);box-shadow:0 4px 24px rgba(180,150,100,0.08); }
        .svc-header { display:flex;align-items:center;gap:16px; }
        .svc-icon { font-size:30px;color:var(--saffron); }
        .svc-titles { flex:1; }
        .svc-title { font-family:var(--serif);font-size:24px;color:var(--maroon);font-weight:700; }
        .svc-title-hi { font-family:var(--hindi);font-size:15px;color:var(--saffron-deep);margin-top:1px; }
        .svc-arrow { font-size:20px;color:var(--text-muted);transition:transform 0.2s; }
        .svc-card.open .svc-arrow { transform:rotate(180deg); }
        .svc-body { margin-top:20px;padding-top:20px;border-top:1px solid var(--border); }
        .svc-desc { font-size:17px;color:var(--text-secondary);line-height:1.75;font-weight:300;margin-bottom:16px; }
        .svc-highlights { display:flex;flex-wrap:wrap;gap:8px; }
        .svc-tag {
          background:rgba(212,130,10,0.08);color:var(--saffron-deep);
          padding:6px 14px;border-radius:100px;font-size:13px;font-weight:500;
        }

        .about-bg { background:var(--bg-warm); }
        .stats-row { display:flex;gap:24px;flex-wrap:wrap; }
        .stat-box {
          flex:1;min-width:160px;text-align:center;padding:28px 16px;
          background:var(--bg-card);border:1px solid var(--border);border-radius:var(--radius);
        }
        .stat-num { font-family:var(--serif);font-size:40px;color:var(--saffron);font-weight:700; }
        .stat-label { font-size:14px;color:var(--text-secondary);margin-top:4px;line-height:1.5; }

        .testimonial-section { text-align:center; }
        .t-container { max-width:620px;margin:0 auto;min-height:200px;display:flex;flex-direction:column;align-items:center;justify-content:center; }
        .t-quote {
          font-family:var(--serif);font-size:20px;line-height:1.7;
          color:var(--text);font-style:italic;font-weight:400;margin-bottom:20px;
          position:relative;
        }
        .t-quote::before {
          content:"❝";font-size:48px;color:var(--saffron-light);
          position:absolute;top:-16px;left:-8px;line-height:1;opacity:0.6;
        }
        .t-name { font-size:15px;font-weight:600;color:var(--maroon); }
        .t-loc { font-size:13px;color:var(--text-muted);margin-top:2px; }
        .t-dots { display:flex;gap:8px;justify-content:center;margin-top:24px; }
        .t-dot {
          width:9px;height:9px;border-radius:50%;border:1.5px solid var(--saffron);
          background:transparent;cursor:pointer;padding:0;transition:all 0.2s;
        }
        .t-dot.active { background:var(--saffron); }

        .contact-bg { background:var(--bg-warm); }
        .contact-cards { display:grid;grid-template-columns:repeat(2,1fr);gap:20px;margin-top:40px; }
        .cc {
          text-align:center;padding:32px 20px;background:var(--bg-card);
          border:1px solid var(--border);border-radius:var(--radius);transition:border-color 0.2s;
        }
        .cc:hover { border-color:var(--saffron); }
        .cc-icon { font-size:28px;margin-bottom:12px; }
        .cc-method { font-family:var(--serif);font-size:20px;color:var(--maroon);margin-bottom:6px;font-weight:700; }
        .cc-detail { font-size:15px;color:var(--text-secondary);line-height:1.6;margin-bottom:14px;font-weight:300; }
        .cc-link { color:var(--saffron-deep);text-decoration:none;font-size:14px;font-weight:600; }
        .cc-link:hover { color:var(--saffron); }

        .footer { text-align:center;padding:36px 24px;border-top:1px solid var(--border); }
        .footer-brand { font-family:var(--serif);color:var(--maroon);font-size:15px;margin-bottom:4px;font-weight:600; }
        .footer-text { font-size:12px;color:var(--text-muted); }

        .mobile-menu {
          position:fixed;inset:0;z-index:99;background:rgba(251,247,240,0.98);
          backdrop-filter:blur(12px);display:flex;flex-direction:column;
          align-items:center;justify-content:center;gap:28px;
        }
        .mobile-menu a { color:var(--maroon);text-decoration:none;font-size:20px;font-weight:500;cursor:pointer;font-family:var(--serif); }
        .mobile-close { position:absolute;top:16px;right:20px;background:none;border:none;color:var(--maroon);font-size:28px;cursor:pointer;z-index:102; }

        @media (max-width:768px) {
          .nav-links,.nav-cta { display:none; }
          .hamburger { display:block; }
          .contact-cards { grid-template-columns:1fr; }
          .section { padding:56px 18px; }
          .nav { padding:10px 18px; }
          .hero { padding:120px 18px 40px; }
          .stats-row { flex-direction:column; }
          .svc-card { padding:24px 18px; }
          .nav-brand img { height:44px;width:44px; }
        }
      `}</style>

      {/* NAV */}
      <nav className={`nav ${scrolled ? "scrolled" : ""}`}>
        <div className="nav-brand" onClick={() => scrollTo("hero")}>
          <img src={LOGO_B64} alt="logo" />
          <span className="nav-brand-text">Shree Ji</span>
        </div>
        <ul className="nav-links">
          <li><a onClick={() => scrollTo("services")}>Services</a></li>
          <li><a onClick={() => scrollTo("about")}>About</a></li>
          <li><a onClick={() => scrollTo("reviews")}>Reviews</a></li>
          <li><a onClick={() => scrollTo("contact")}>Contact</a></li>
        </ul>
        <button className="nav-cta" onClick={() => window.open(`https://wa.me/${WA}?text=${encodeURIComponent("Namaste, I would like to book a consultation.")}`, "_blank")}>
          Book on WhatsApp
        </button>
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? "✕" : "☰"}
       </button>
      </nav>

      {menuOpen && (
        <div className="mobile-menu">
         
          <a onClick={() => scrollTo("services")}>Services</a>
          <a onClick={() => scrollTo("about")}>About</a>
          <a onClick={() => scrollTo("reviews")}>Reviews</a>
          <a onClick={() => scrollTo("contact")}>Contact</a>
        </div>
      )}

      {/* HERO */}
      <section className="hero" id="hero">
      <FloatingMandala size={320} top="-50px" left="-70px" opacity={0.25} speed={100} delay={0} />
      <FloatingMandala size={220} top="10%" right="-40px" opacity={0.2} speed={140} delay={5} />
      <FloatingMandala size={280} top="50%" left="-50px" opacity={0.18} speed={120} delay={10} />
      <FloatingMandala size={200} top="68%" right="3%" opacity={0.22} speed={160} delay={3} />
      <FloatingMandala size={260} top="28%" right="-90px" opacity={0.15} speed={90} delay={7} />
      <FloatingMandala size={160} top="82%" left="8%" opacity={0.2} speed={130} delay={12} />
      <FloatingMandala size={180} top="40%" left="15%" opacity={0.12} speed={170} delay={8} />
      <FloatingMandala size={240} top="5%" right="20%" opacity={0.14} speed={110} delay={15} />
      <FloatingMandala size={140} top="90%" right="15%" opacity={0.18} speed={150} delay={2} />
      <FloatingMandala size={200} top="60%" left="30%" opacity={0.1} speed={180} delay={20} />

        <div className="hero-content">
          <div className="hero-eyebrow">{YEARS}+ Years of Vedic Practice</div>
          <h1 className="hero-name">{NAME}</h1>
          <p className="hero-tagline-hi">वैदिक ज्योतिषी · अंक शास्त्री · टैरो रीडर</p>
          <p className="hero-tagline">Vedic Astrologer · Numerologist · Tarot Reader</p>
          <p className="hero-intro">
            Guiding individuals and families through life's crossroads with ancient wisdom,
            compassion, and remedies that work — in Hindi, Punjabi or English, by call, video, or in person.
          </p>

          {/* Service pills right in hero */}
          <div className="service-pills">
            {SERVICES.map((s, i) => (
              <div key={i} className="service-pill" onClick={() => scrollTo("services")}>
                <span className="pill-icon">{s.icon}</span> {s.title}
              </div>
            ))}
          </div>

  
        </div>
      </section>

      {/* SERVICES */}
      <section className="section" id="services">
        <div className="section-label">What She Offers</div>
        <h2 className="section-title">Services</h2>
        <p className="section-sub">
          Every session is personal and unhurried — no generic computer reports.
          Each insight is hand-analysed, each remedy tailored to you.
        </p>
        <div className="services-detail">
          {SERVICES.map((s, i) => (
            <div key={i} className={`svc-card ${expandedService === i ? "open" : ""}`} onClick={() => setExpandedService(expandedService === i ? null : i)}>
              <div className="svc-header">
                <span className="svc-icon">{s.icon}</span>
                <div className="svc-titles">
                  <div className="svc-title">{s.title}</div>
                  <div className="svc-title-hi">{s.titleHi}</div>
                </div>
                <span className="svc-arrow">▾</span>
              </div>
              {expandedService === i && (
                <div className="svc-body">
                  <div className="svc-desc">{s.desc}</div>
                  <div className="svc-highlights">
                    {s.highlights.map((h, j) => (
                      <span key={j} className="svc-tag">{h}</span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* ABOUT */}
      <div className="about-bg">
        <section className="section" id="about" style={{ position: "relative", overflow: "hidden" }}>
        <FloatingMandala size={240} top="-30px" right="-80px" opacity={0.22} speed={150} delay={2} />
        <FloatingMandala size={180} top="60%" left="-60px" opacity={0.25} speed={120} delay={6} />
        <FloatingMandala size={200} top="30%" right="10%" opacity={0.22} speed={170} delay={9} />
          <div style={{ position: "relative", zIndex: 1 }}>
            <div className="section-label">About</div>
            <h2 className="section-title">Rooted in tradition.<br />Relevant to your life today.</h2>
            <p className="section-sub">
              With over {YEARS} years of deep study in Jyotish Shastra, Ank Vidya, and Tarot,
              she brings a rare blend of scriptural knowledge and real-world empathy.
              Every consultation is personal, unhurried, and focused on remedies you can actually follow.
            </p>
            <div className="stats-row">
              <div className="stat-box">
                <div className="stat-num">{YEARS}+</div>
                <div className="stat-label">Years of dedicated<br/>Jyotish practice</div>
              </div>
              <div className="stat-box">
                <div className="stat-num">4,000+</div>
                <div className="stat-label">Charts analysed &<br/>lives guided</div>
              </div>
              <div className="stat-box">
                <div className="stat-num">Hindi, Punjabi & English</div>
                <div className="stat-label">Consultations in<br/>your preferred language</div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* TESTIMONIALS */}
      <section className="section testimonial-section" id="reviews">
        <div className="section-label">What Clients Say</div>
        <h2 className="section-title">Trusted by thousands</h2>
        <div style={{ width: 40, height: 2, background: "var(--saffron-light)", margin: "0 auto 36px", borderRadius: 2 }} />
        <div className="t-container">
          <div className="t-quote">{TESTIMONIALS[activeT].text}</div>
          <div className="t-name">{TESTIMONIALS[activeT].name}</div>
          <div className="t-loc">{TESTIMONIALS[activeT].loc}</div>
          <div className="t-dots">
            {TESTIMONIALS.map((_, i) => (
              <button key={i} className={`t-dot ${i === activeT ? "active" : ""}`} onClick={() => setActiveT(i)} />
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <div className="contact-bg">
        <section className="section" id="contact" style={{ textAlign: "center" }}>
          <div className="section-label">Get in Touch</div>
          <h2 className="section-title">Ready to begin?</h2>
          <p className="section-sub" style={{ margin: "0 auto 0" }}>
            Reach out through whichever channel feels comfortable.
            First-time consultations are always welcoming and pressure-free.
          </p>
          <div className="contact-cards">
            <div className="cc">
              <div className="cc-icon">💬</div>
              <div className="cc-method">WhatsApp</div>
              <div className="cc-detail">Quickest way to book.<br/>Usually replies within an hour.</div>
              <a className="cc-link" href={`https://wa.me/${WA}?text=${encodeURIComponent("Namaste, I would like to book a consultation.")}`} target="_blank" rel="noopener">CHAT NOW →</a>
            </div>
      
            <div className="cc">
              <div className="cc-icon">✉️</div>
              <div className="cc-method">Email</div>
              <div className="cc-detail">For detailed queries or<br/>sending birth details in advance.</div>
              <a className="cc-link" href={`mailto:${EMAIL}?subject=${encodeURIComponent("Consultation Inquiry")}`}>Send Email →</a>
            </div>
          </div>
        </section>
      </div>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-brand">{NAME}</div>
        <div className="footer-text">© {new Date().getFullYear()} · All rights reserved</div>
      </footer>
    </div>
  );
}
